document.addEventListener("DOMContentLoaded", function(event) {

  //Expand menu and update arias for usability functionlaity
  function expandMenu(elem){
    elem.parentNode.classList.toggle("expanded");
    
    if (elem.parentNode.parentNode.getAttribute('aria-expanded') == "true"){
    	elem.parentNode.parentNode.setAttribute('aria-expanded', "false");
    } else {
      elem.parentNode.parentNode.setAttribute('aria-expanded', "true");
    }
  }

  document.querySelectorAll(".icon-dropdown").forEach(elem => {
    elem.addEventListener("click", function(){
      expandMenu(elem);
    });
    
    elem.addEventListener('keydown', (evnt) => {
      if (evnt.code === 'Space' || evnt.code === 'Enter') {
        expandMenu(elem);
      }
    });
    
  });
  
  //When user selects a new variant, update the price
  document.querySelector("select[name='id']").addEventListener('change', (event) => {
    let e = document.querySelector("select[name='id']");
    document.querySelector("#price").innerText = e.options[e.selectedIndex].dataset.price;
    
    
    document.querySelector("#compare_at").innerText = e.options[e.selectedIndex].dataset.compare_at;
  });
 
});
  